import * as React from 'react';
require('./style.scss');

interface IProps {
	leftColumnContent: JSX.Element;
	rightColumnContent: JSX.Element;
}

class TwoColumnPage extends React.Component<IProps, {}> {
	/* RENDER */
	public render() {
		const { leftColumnContent, rightColumnContent } = this.props;
		return (
			<div className="twoColumnPageWrapper">
				<div className="contentLeft">{leftColumnContent}</div>
				<div className="contentRight">{rightColumnContent}</div>
			</div>
		);
	}
}
export { TwoColumnPage };
